import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenSpinner } from "../components/exports";
import { getAuthManager } from "../utils/auth";

export default function Impersonate () {
    const query = new URLSearchParams(window.location.search);
    const code = query.get("c") ?? "";
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('did');
        const authManager = getAuthManager();
        authManager.exchangeTicket(code).then(r => {
            navigate("/");
        });
    }, [code, navigate]);

    return <FullScreenSpinner />;
}
